/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import SettingsIcon from "@material-ui/icons/Settings";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import { Pay } from "./Pay";
import { Fees } from "./Fees";
import { Calculate } from "./Calculate";
import { Review } from "./Review";

export const Billing = () => {
  const { user } = useSelector((state) => state.auth);
  const TENANT_ID = user.selectedTenant;

  const [step, setStep] = useState(0);
  const [reviewedItem, setReviewedItem] = useState({});

  const handleNextStep = () => setStep(step + 1);

  const handlePrevStep = () => setStep(step - 1);

  const stepsContent = [
    <Calculate
      handlePrevStep={handlePrevStep}
      handleNextStep={handleNextStep}
      tenantId={TENANT_ID}
      setReviewedItem={setReviewedItem}
      setStep={setStep}
    />,

    <Review
      handlePrevStep={handlePrevStep}
      handleNextStep={handleNextStep}
      reviewedItem={reviewedItem}
      tenantId={TENANT_ID}
      setReviewedItem={setReviewedItem}
    />,

    <Fees
      handlePrevStep={handlePrevStep}
      handleNextStep={handleNextStep}
      reviewedItem={reviewedItem}
      setReviewedItem={setReviewedItem}
      tenantId={TENANT_ID}
    />,
    <Pay reviewedItem={reviewedItem} setStep={setStep} tenantId={TENANT_ID} />,
  ];

  const steps = [
    {
      label: "Calculate",
      icon: <PersonAddIcon fontSize="large" />,
      key: "calculate",
    },
    {
      label: "Review",
      icon: <SettingsIcon fontSize="large" />,
      key: "review",
    },
    {
      label: "Fees",
      icon: <SettingsIcon fontSize="large" />,
      key: "fees",
    },
    {
      label: "Finalise Billing",
      icon: <PersonAddIcon fontSize="large" />,
      key: "pay",
    },
  ];

  return (
    <>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map(({ label }) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div className="mt-5">
        {stepsContent.find((item, index) => index === step)}
      </div>
    </>
  );
};
